import React from 'react';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { reCaptchaSiteKey } from './config';

const queryClient = new QueryClient();

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaSiteKey}>
      <QueryClientProvider client={queryClient}>
        {element}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  );
};
